import useApp from "./useApp";
import router from "@/router";
import axios from "@/axios"

const passwordReset = () => {
    const { validEmail, host, ToastMsgSuccess, ToastMsgError, ToastMsgInfo } = useApp()
    let data = {
        errors: [],
        user: {
            email: "",
            link: ""
        }
    }

    const reset_password = () => {
        axios
            .post("/reset-password", data.user)
            .then(res => {

                //success! - Usuario creado.
                if (res.data.status == "success") {
                    ToastMsgInfo("Se ha Enviado Un Correo Para cambiar tu Contraseña !", "user", 5000)
                    router.push('/login');

                    return;
                }

            })
            .catch(e => {

                if (e.response == undefined) {
                    ToastMsgError("Error Api Server !", "user", 5000)
                    return
                }

                if (e.response.data.status == "error") {
                    ToastMsgInfo("Error Server Response !", "server", 5000)
                    return

                }
                ToastMsgError("Undefined Error !", "server", 5000)
                return

            })
    }

    const check_form = () => {
        data.errors = [];
        const email = data.user.email
        if (email == ""){
            data.errors.push("- Campo Email Vacio !")
        } else if (!validEmail(email)) {
            data.errors.push("- Campo Email No Valido !")
        }

        if (data.errors.length == 0) {
            data.user.link = host + "/password-change?token=";
            reset_password();
        }

        data.errors.map((msg)=>{
            ToastMsgInfo(msg,"user",5000)
        })

    }

return {
    check_form,
    data
}
}


export default passwordReset